import React, {useEffect, useState} from 'react';
import {get2FAValidity} from "v4/pages/front/Login/hooks/useLogin";
import {useTranslation} from "react-i18next";

export default function Login2FaRemainingTime() {
    const {t} = useTranslation();
    const [remainingTime, setRemainingTime] = useState(new Date(get2FAValidity().remainingTime));

    useEffect(() => {
        const interval = setInterval(() => {
            setRemainingTime(prevTime => {
                const newTime = new Date(prevTime);
                // Decrease the time by 1 second
                newTime.setSeconds(newTime.getSeconds() - 1);

                return newTime;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <p style={{marginBottom: '1rem', color: 'var(--main-color)'}}>
            <span>{t('remaining_time')} : </span>
            <span style={{fontWeight: 'bold'}}>
                {remainingTime.toLocaleTimeString([], {
                    minute: '2-digit',
                    second: '2-digit',
                })}
            </span>
        </p>
    )
}
